var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TopHeader'),_c('loginTan',{ref:"loginTan"}),_c('router-view'),_c('right'),_c('Footers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }